var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.cmpList[_vm.tmpType],{tag:"component",attrs:{"comData":_vm.comData,"isEdit":_vm.isEdit}})}
var staticRenderFns = []

export { render, staticRenderFns }